import { makeVar } from '@apollo/client';
import { ScannerCaseAuthStatus } from 'models/scanner-case';

export const threeShapeStatusVar = makeVar<ScannerCaseAuthStatus>({
    enabled: false,
    authorized: false,
    clientId: '',
    codeChallenge: '',
});

export const meditStatusVar = makeVar<ScannerCaseAuthStatus>({
    enabled: false,
    authorized: false,
    clientId: '',
    state: '',
});

export const dexisStatusVar = makeVar<ScannerCaseAuthStatus>({
    enabled: false,
    authorized: false,
    clientId: '',
});

export const pandaStatusVar = makeVar<ScannerCaseAuthStatus>({
    enabled: false,
    authorized: false,
    clientId: '',
});

export const pandaEuStatusVar = makeVar<ScannerCaseAuthStatus>({
    enabled: false,
    authorized: false,
    clientId: '',
});

export const dsCoreStatusVar = makeVar<ScannerCaseAuthStatus>({
    enabled: false,
    authorized: false,
    clientId: '',
});
